export default __webpack_public_path__ + "static/NAPPA-seal-2021-753c218284deb24686242117c2483cf7.png";